import { LogLevel, type Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "a25ae2e9-26d6-40df-9a6f-3bdccc22aa7d",
    authority: import.meta.env.VITE_AZURE_AUTHORITY || "https://login.microsoftonline.com/856ea157-bf1d-43df-af37-bbfbc0072578",
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || "https://luke.deal-os.net",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // @ts-expect-error allowNativeBroker is not in current type definitions but is valid
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            return;
        }
      },
    },
    windowHashTimeout: 60000, // Increase timeout for iframe operations
    iframeHashTimeout: 10000,
    navigateFrameWait: 500 // Add delay to prevent race conditions
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "User.Read"
  ],
};

export const silentRequest = {
  scopes: ["openid", "profile", "User.Read"],
  account: null,
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};